import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  // HttpResponse,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CookieService } from 'angular2-cookie/core';
// import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LOCAL_STORAGE } from '../app/constants/localstorage.constant';
import { COOKIES } from '../app/constants/cookies.constant';

@Injectable()
export class Interceptor implements HttpInterceptor {

  constructor(
    public router: Router,
    private cookie: CookieService) { }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Authorization: 'Bearer_auth=' + this.cookie.get(COOKIES.BEARER_AUTH)
      },
    });

    return next.handle(request).pipe(
      catchError((errorResponse: any) => {
        if (errorResponse instanceof HttpErrorResponse) {
          if (errorResponse.status === 401 && errorResponse.error) {
            const { status, status_message } = errorResponse.error;
            if (status === 5) {
              localStorage.setItem(LOCAL_STORAGE.KEYS.TOKEN_VALID, 'false');
              this.router.navigate(['/pages/auth/login-2']);
            }
          }
        }
        return of(errorResponse);
      })
    );
  }
}
